import trackUtil from '@/utils/analytics-service';
import { buildAnalyticsContext } from '@/hooks/useAnalyticsContext';
import { GraphResultsViewedProps } from '@/utils/analytics/types';
import { WorkspaceT } from '@/pages/workgroup/type';

type GraphResultsViewedInput = Omit<
  GraphResultsViewedProps,
  'user_id' | 'organization_id' | 'workgroup_id' | 'database_id' | 'workspace_id' | 'graph_id'
> & {
  graph_id?: string;
  workgroup_id?: string;
  workspace_id?: string;
  database_id?: string;
};

export function trackGraphResultsViewedEvent(
  props: GraphResultsViewedInput,
  sources: {
    userId?: string;
    organizationId?: string;
    workspace?: WorkspaceT | null;
    graphId?: string;
  }
) {
  const context = buildAnalyticsContext(
    {
      workgroup_id: props.workgroup_id,
      workspace_id: props.workspace_id,
      database_id: props.database_id,
      graph_id: props.graph_id,
    },
    {
      userId: sources.userId,
      organizationId: sources.organizationId,
      workspace: sources.workspace,
      graphId: sources.graphId,
    }
  );

  const { user_id, organization_id, workgroup_id, workspace_id, database_id, graph_id } = context;

  if (!user_id || !organization_id || !workgroup_id || !database_id || !workspace_id || !graph_id) {
    return;
  }

  trackUtil.trackGraphResultsViewed({
    ...props,
    user_id,
    organization_id,
    workgroup_id,
    database_id,
    workspace_id,
    graph_id,
  });
}
